// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"OnePicture_thecomp__kUbGE"};